import React, { useMemo } from "react";

import { useQuery } from "@apollo/client";

import Modal from "components/common/Modal";
import SelectField from "components/common/inputs/Select/SelectField";

import useModal from "hooks/useModal";

import getVariablesForJurisdictionQuery from "utils/jurisdiction/getVariablesForJurisdictionQuery";

import ALL_JURISDICTIONS from "@gql/sanity/allJurisdictions";

export const CHANGE_DOCUMENT_JURISDICTION_MODAL_NAME = "CHANGE_DOCUMENT_JURISDICTION";

const ChangeJurisdictionModal = () => {
  const { options = {}, close, setDisabled } = useModal(CHANGE_DOCUMENT_JURISDICTION_MODAL_NAME);
  const { currentValue, onChange } = options;

  const { data, loading } = useQuery(ALL_JURISDICTIONS, {
    variables: getVariablesForJurisdictionQuery(),
  });

  const jurisdictionOptions = useMemo(() => {
    const jurisdictions = [];
    if (data?.allCountry) jurisdictions.push(...data.allCountry);
    if (data?.allProvince) jurisdictions.push(...data.allProvince);
    return jurisdictions.map((j) => ({ value: j.shorthand, label: j.name }));
  }, [data]);

  const [selected, setSelected] = React.useState(currentValue || "");

  const handleSubmit = (e) => {
    e.preventDefault();
    setDisabled(true);
    try {
      onChange?.(selected);
      close();
    } finally {
      setDisabled(false);
    }
  };

  return (
    <Modal
      size="sm"
      name={CHANGE_DOCUMENT_JURISDICTION_MODAL_NAME}
      form={CHANGE_DOCUMENT_JURISDICTION_MODAL_NAME}
      title="Change Jurisdiction"
      submitButtonTitle="Apply"
      showCloseButton
      onSubmitClick={handleSubmit}
    >
      <form id={CHANGE_DOCUMENT_JURISDICTION_MODAL_NAME} onSubmit={handleSubmit}>
        <SelectField
          name="jurisdiction"
          options={jurisdictionOptions}
          containerClassName="mb-3"
          label="Jurisdiction"
          isLoading={loading}
          value={selected}
          onChange={({ value }) => setSelected(value)}
          placeholder="Select Jurisdiction"
        />
      </form>
    </Modal>
  );
};

export default ChangeJurisdictionModal;
